import "./frontend.scss"
import React, { useState} from "react"
import ReactDOM from "react-dom"

const link = document.createElement('link');

link.rel = 'stylesheet';
link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css';

document.head.appendChild(link);


const divsToUpdate = document.querySelectorAll(".boilerplate-update-me")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  ReactDOM.render(<OurComponent {...data} />, div)
  div.classList.remove("boilerplate-update-me")
})



function OurComponent() {
  const [formValues, setFormValues] = useState({name: '', phone: '', email: '', message: ''});
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prevValues => ({ ...prevValues, [name]: value })); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formValues.name) {
      newErrors.name = ("Please enter your name");
    }    

    if (!formValues.phone) {
      newErrors.phone = ("Please enter your phone");
    }   
     if (!formValues.email) {
      newErrors.email = ("Please enter your email");
    }  
      if (!formValues.message) {
      newErrors.message = ("Please enter your message");
    }



    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Set error messages if validation fails
      return;
    }

    setErrors({});
    const currentDate = new Date().toISOString();
    const formData = {
      "title": "client Info",
      name: formValues.name,
      phone: formValues.phone,
      email: formValues.email,
      message: formValues.message,
      date: currentDate
    }
    const jsonFormData = JSON.stringify(formData);
    try {
    const response = await fetch('https://www.darrellsboatandrvstorage.com/wp-json/submit/v1/data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: jsonFormData,
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const result = await response.json();
    console.log('Success:', result);
  } catch (error) {
    console.error('Error:', error);
    setErrorMessage('There was a problem with your submission. Please try again or click below to schedule an appointment');

  }
  setStep(2)
  return true;  
  }

  return (
    <>
    <div className="boilerplate-frontend"> 
      {     step === 1 ? (
        <>
      <h3 className="form-h3"><span class="first"> CONTACT </span> US</h3> 
     <form onSubmit={handleSubmit}>
     <div className="form-group">
<input type="input"
  id="name" 
  name="name" 
  value={formValues.name}
  onChange={handleChange}
  placeholder="Name"
  title="Enter your name"
/>
{errors.name && (
  <>
  <p className="error-message">{errors.name}</p>
  </>
)}
</div>


<div className="form-group">
<input type="input"
  id="phone" 
  name="phone" 
  value={formValues.phone}
  onChange={handleChange}
  placeholder="phone"

  title="Enter your phone"
/>
{errors.phone && (
  <>
  <p className="error-message">{errors.phone}</p>
  </>
)}
</div>

<div className="form-group">
<input type="input"
  id="email" 
  name="email" 
  value={formValues.email}
  onChange={handleChange}
  placeholder="email"

  title="Enter your email"
/>
{errors.email && (
  <>
  <p className="error-message">{errors.email}</p>
  </>
)}
</div>

<div className="form-group">
<textarea 
  id="message" 
  name="message" 
  value={formValues.message}
  onChange={handleChange}
  placeholder="message"
tabindex="5"
  title="Enter your message"
/>
{errors.message && (
  <>
  <p className="error-message">{errors.message}</p>
  </>
)}
</div>
<div class="btn-margin">
<button className="btn" type="submit">Submit</button>
 
    </div>
    
</form>
</>
      ) :  (
        <>
          <i className="fa-solid fa-square-check fa-beat form-icon" ></i>
        <div className="hello">
          <h2>
          Thanks for Submitting
          </h2>
        </div>
    
        <a className="btn" href="/">Back Home</a>
        
        </>
      )
    }
    </div>
    </>
  );
}